import { useMemo } from 'react';
import { useLyftSocket } from '@src/hooks';
import {
  buildSeedFromSegment,
  isChatEnabledStatus,
} from '@component/DriverChat/helpers';
import {
  DriverChatSeed,
  DriverConversation,
} from '@component/DriverChat/types';

/**
 * Segments whose driver has accepted the ride (live status in the "In
 * progress" group, driver assigned) and that have no conversation yet, built
 * from the same live `socketStatus` the rest of the app uses.
 */
export const useStartableSegments = (
  enabled: boolean,
  conversations: DriverConversation[]
): DriverChatSeed[] => {
  const { socketStatus } = useLyftSocket();

  return useMemo(() => {
    if (!enabled) return [];
    const hasConversation = new Set(conversations.map((c) => c.segmentId));

    return Object.entries(socketStatus ?? {}).flatMap(
      ([id, live]: [string, any]) => {
        const driver = live?.fullInfo?.driver;
        if (
          !driver?.first_name ||
          !isChatEnabledStatus(live.statusId) ||
          hasConversation.has(Number(id))
        ) {
          return [];
        }
        const seed = buildSeedFromSegment({
          id,
          rideId: live.rideId,
          statusId: live.statusId,
          driver,
          vehicle: live.fullInfo.vehicle,
        });
        return seed ? [seed] : [];
      }
    );
  }, [enabled, conversations, socketStatus]);
};
